import { Injectable } from '@angular/core';

import * as moment from 'moment-timezone';

const shortZones = [
  'UTC',
  'US/Central',
  'US/Eastern',
  'US/Mountain',
  'US/Pacific',
  'US/Alaska',
  'US/Arizona',
  'US/Hawaii',
  'Africa/Addis_Ababa',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'America/Mexico_City',
  'America/Sao_Paulo',
  'Asia/Bangkok',
  'Asia/Hong_Kong',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Australia/Adelaide',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Moscow',
  'Europe/Paris',
  'Europe/Rome',
  'Europe/Zurich',
  'Pacific/Auckland'
  ];

@Injectable()
export class TimezoneService {

  constructor() { }

  public getZoneNames() {
    // return moment.tz.names();
    return shortZones;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/timezones.service.ts